import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class TabsTwo extends Component{
    render(){
        let
            tab1 = "Selected Experience",
            tab2 = "Education";
        
        const { tabStyle } = this.props
        return(
            <div>
                {/* Start Tabs Area */}
                <div className="tabs-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Tabs>
                                    <TabList  className={`${tabStyle}`}>
                                        <Tab>{tab1}</Tab>
                                        <Tab>{tab2}</Tab>
                                    </TabList>

                                    <TabPanel>
                                       <div className="single-tab-content">
                                           <ul>
                                               <li>
                                                   <span className="tab-item">
                                                       Rackspace | <span>Principal Forward Deployed Engineer (Palantir Foundry)</span>
                                                   </span>
                                                   {" "}2026 - Present
                                                </li>
                                               <li>
                                                   <span className="tab-item">
                                                       Rackspace | <span>AI Architect (Public Cloud)</span>
                                                   </span>
                                                   {" "}2025 - 2026
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        Rackspace | <span>AI Manager (CTO Organization / FAIR)</span>
                                                    </span>
                                                    {" "}2024 - 2025
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        Private Consultant | <span>AI/ML Engineer</span>
                                                    </span>
                                                    {" "}2023 - 2024
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        Agmonitor | <span>Data Scientist</span>
                                                    </span>
                                                    {" "}2022 - 2023
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        vRad | <span>Software Engineer</span>
                                                    </span>
                                                    {" "}2021 - 2022
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        Phylagen | <span>Data Scientist</span>
                                                    </span>
                                                    {" "}2020 - 2021
                                                </li>
                                           </ul>
                                       </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="single-tab-content">
                                            <ul>
                                                <li>
                                                    <span className="tab-item">
                                                        University of San Francisco | <span>M.S. Data Science</span>
                                                    </span>
                                                    {" "}2023
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        University of Maryland | <span>M.S. Physics</span>
                                                    </span>{" "}
                                                    2018
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        University of San Francisco |{" "}
                                                        <span>MBA, Business Analytics</span>
                                                    </span>
                                                    {" "}Expected 2026
                                                </li>
                                                <li>
                                                    <span className="tab-item">
                                                        Santa Clara University |{" "}
                                                        <span>B.S. Physics / Mathematics</span>
                                                    </span>
                                                    {" "}2012
                                                </li>
                                            </ul>
                                        </div>
                                    </TabPanel>  
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Tabs Area */}
            </div>
        )
    }
}



export default TabsTwo;
